import React from "react";
import {
  Create,
  FormDataConsumer,
  SelectInput,
  TextInput,
  BooleanInput,
  required,
  ReferenceInput,
  ImageInput,
  ImageField,
  TabbedForm,
  SimpleForm,
  FormTab,
  DateInput, NumberInput,
  useNotify
} from "react-admin";
import { useStyles } from "../../../formStyles";
import { FormToolbar } from "../../../common/FormToolbar";
import moment from "moment";
import * as apiClient from "../../../common/apiClient";
import { toast } from "react-toastify";

const PolicyTypeCreate = (props) => {
  const classes = useStyles({});
  const notify = useNotify();
  let defaultValues = {
    isActive: true,
    code: "-",
    isNonTarrif: false,
    isRenewalMail: false,
  };
  const handleSubmit = async (formdata) => {
    let user: any = localStorage.getItem("userId");
    if (user) {
      user = parseInt(user);
    }
    let m = moment();

    let data = { ...formdata };
    data.modifyBy = user;
    data.createdBy = user;
    data.modifyDate = m.toISOString();
    data.createdDate = m.toISOString();

    apiClient.addRecord(data, "life-policy-types").then(res => {
      notify("Policy Type is added succesffully");
      props.onClose();

    }).catch(err => {
      notify("unable to add Policy Type", "warning");
      toast.error("Validation issue : " + err, {
        position: "bottom-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        });
      console.log(err);
    });
  }

  return (
    <React.Fragment>
      <h5>Add Policy Type </h5>
      <SimpleForm variant="outlined" toolbar={<FormToolbar {...props} showDelete={false} showCancel={true} onCancel={props.onClose} onSave={handleSubmit} />} redirect="list" onSubmit={handleSubmit} initialValues={defaultValues} >

        <TextInput source="code" fullWidth={true} validate={[required()]} formClassName={classes.first_inline_input} />
        <TextInput source="name" fullWidth={true} validate={[required()]} formClassName={classes.last_inline_input}/>
        <ReferenceInput label="Policy Category " fullWidth={true} validate={[required()]} source="policyCategoryId"  formClassName={classes.first_inline_input} 
        reference="policy-categories" >
          <SelectInput optionText="name" />
        </ReferenceInput>

        <ReferenceInput label="Policy Department " fullWidth={true} validate={[required()]} source="policyDepartmentId" formClassName={classes.last_inline_input}
        reference="life-policy-departments" >
          <SelectInput optionText="name" />
        </ReferenceInput>


        <BooleanInput source="isNonTarrif" validate={[required()]} label="Is Non Tarrif" formClassName={classes.first_inline_input} />
        <BooleanInput source="isNonPos" validate={[required()]} label="Is Non Pos" formClassName={classes.last_inline_input} />
        <BooleanInput source="isTpa" validate={[required()]} label="Is TPA" formClassName={classes.first_inline_input} />
        <BooleanInput source="isRenewalMail" validate={[required()]} label="is Renewal Mail" formClassName={classes.last_inline_input} />
        <BooleanInput source="isActive" validate={[required()]} label="Active" initialValue={true}/>

      </SimpleForm>

    </React.Fragment>
  );
};
export default PolicyTypeCreate;